<script setup lang="ts">
import VTooltip from "@magnit/core/src/components/VTooltip/VTooltip.vue";
import VHidden from "@magnit/core/src/components/VHidden/VHidden.vue";
import VModal from "@magnit/core/src/components/VModal/VModal.vue";
import ShopSelectPromptContent from "@magnit/unit-shop-select/src/components/ShopSelectPromptContent.vue";
import type { IShopSelectStorePrompt } from "@magnit/unit-shop-select/src/shop-select.types";

const props = withDefaults(defineProps<IShopSelectStorePrompt>(), {
  description: "Оставить выбранный магазин?",
  subDescription: "Вы увидите его акции и каталог товаров",
  approveLabel: "Да, оставить",
  rejectLabel: "Нет, поменять",
});

const emit = defineEmits<{
  approve: [];
  reject: [];
}>();

const onApprove = () => emit("approve");
const onReject = () => emit("reject");
</script>

<template>
  <VHidden :hide="{ xs: true, m: false }" class="store-select-prompt">
    <VTooltip
      v-if="show"
      show-on-create
      interactive
      :offset="[0, -12]"
      :max-width="480"
      :show-arrow="false"
      :hide-on-click="false"
      :closable="false"
      trigger="manual"
      placement="bottom-end"
    >
      <template #content>
        <ShopSelectPromptContent
          v-bind="props"
          @approve="onApprove"
          @reject="onReject"
        />
      </template>
    </VTooltip>
  </VHidden>

  <VModal
    id="store"
    :closable="false"
    wrapper-class="store-select-prompt__bottom-sheet"
    active
    :open="show"
    type="bottom-sheet"
  >
    <ShopSelectPromptContent
      v-bind="props"
      @approve="onApprove"
      @reject="onReject"
    />
  </VModal>
</template>

<style lang="postcss" scoped>
.store-select-prompt {
  height: 0;
  width: 0;
  align-self: flex-end;
}

:global(.store-select-prompt__bottom-sheet) {
  @media (--pl-viewport-from-m) {
    display: none !important;
  }
}
</style>
